import { render } from "./DeleteConfirmationForm.vue?vue&type=template&id=7f988e2e&ts=true"
import script from "./DeleteConfirmationForm.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirmationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__